export class asyncUtils {
	/**
	 * Creates a delay promise that resolves after the specified duration
	 * @param durationMs - Duration in milliseconds to delay
	 * @returns Promise that resolves after the delay
	 */
	// eslint-disable-next-line @typescript-eslint/promise-function-async
	static createDelay(durationMs: number): Promise<void> {
		return new Promise<void>((resolve) => {
			setTimeout(() => {
				resolve();
			}, durationMs);
		});
	}

	/**
	 * Creates a delay with a timeout that can be cancelled
	 * @param durationMs - Duration in milliseconds to delay
	 * @returns Object with promise and cancel function
	 */
	static createCancellableDelay(durationMs: number): { promise: Promise<void>; cancel: () => void } {
		let timeoutId: NodeJS.Timeout;

		const promise = new Promise<void>((resolve) => {
			timeoutId = setTimeout(() => {
				resolve();
			}, durationMs);
		});

		const cancel = () => {
			clearTimeout(timeoutId);
		};

		return { promise, cancel };
	}
}
